<template>
  <div class="invite-friend-count">
    <button
      type="button"
      class="invite-friend-count__inner"
      @click="$emit('click')"
    >
      <img
        class="invite-friend-count__icon"
        src="@/assets/home/icn_invite_color.png"
      />
      <span class="typo-body-m-bold">내가 초대한 친구</span>
      <span class="invite-friend-count__number typo-body-m-bold">{{ count }}명</span>
      <img
        v-if="Number(count)"
        class="invite-friend-count__caret"
        src="@/assets/home/icn_caret_right.png"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: 'InviteFriendCount',
  props: {
    count: {
      type: [Number, String],
      default: '00',
    },
  },
}
</script>

<style scoped>
.invite-friend-count {
  position: relative;
  z-index: 1;
  margin-top: -36px;
  margin-bottom: -36px;
  padding: 0 16px;
}

.invite-friend-count__inner {
  display: flex;
  width: 100%;
  height: 72px;
  padding: 24px 16px;
  align-items: center;
  border: none;
  border-radius: 12px;
  background: var(--color-wb-white, #FFF);
  box-shadow: 0 2px 8px 0 rgba(24, 24, 28, 0.10);
  box-sizing: border-box;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.invite-friend-count__icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin-right: 8px;
}

.invite-friend-count__number {
  margin-left: 12px;
  color: var(--color-text-main, #191F28);
}

.invite-friend-count__caret {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/InviteFriendCount.vue